import React from "react";

import type Stripe from "stripe";
import type { RecurringPlanDefinition } from "common/stripeProducts";

import { PlanSummary as PlanSummaryA } from "./PlanSummaryA";
import { PlanSummary as PlanSummaryB } from "./PlanSummaryB";

export interface PlanSummaryProps {
    isTrial: boolean;
    billingInterval: string;
    productDisplayName: string;
    prices: {
        month: RecurringPlanDefinition;
        year: RecurringPlanDefinition;
    };
    promo: Stripe.PromotionCode;
    availableReferralCredit: number;
    taxAmount?: number;
    expandable?: boolean;
    defaultExpanded?: boolean;

    handleBillingIntervalChange: (billingInterval: string) => void;
    handleVerifyPromoCode: (promo: Stripe.PromotionCode) => Promise<void>;
}

export function PlanSummary({ variant = "A", ...props }: { variant?: "A" | "B" } & PlanSummaryProps) {
    const Component = variant === "A" ? PlanSummaryA : PlanSummaryB;
    return <Component {...props} />;
}
